__turbopack_context__.v({
  "allGamesMessage": "sportschedule-module-scss-module__DjcIfq__allGamesMessage",
  "dateTitle": "sportschedule-module-scss-module__DjcIfq__dateTitle",
  "filterBar": "sportschedule-module-scss-module__DjcIfq__filterBar",
  "filterBarSelect": "sportschedule-module-scss-module__DjcIfq__filterBarSelect",
  "large": "sportschedule-module-scss-module__DjcIfq__large",
  "listStylings": "sportschedule-module-scss-module__DjcIfq__listStylings",
  "loadMoreGames": "sportschedule-module-scss-module__DjcIfq__loadMoreGames",
  "loadMoreMessage": "sportschedule-module-scss-module__DjcIfq__loadMoreMessage",
  "moreGames": "sportschedule-module-scss-module__DjcIfq__moreGames",
  "noGames": "sportschedule-module-scss-module__DjcIfq__noGames",
  "noGamesAnchor": "sportschedule-module-scss-module__DjcIfq__noGamesAnchor",
  "noGamesMsg": "sportschedule-module-scss-module__DjcIfq__noGamesMsg",
  "noGamesTitle": "sportschedule-module-scss-module__DjcIfq__noGamesTitle",
  "noGamesWrapper": "sportschedule-module-scss-module__DjcIfq__noGamesWrapper",
  "scheduleContainer": "sportschedule-module-scss-module__DjcIfq__scheduleContainer",
  "small": "sportschedule-module-scss-module__DjcIfq__small",
  "textStyling": "sportschedule-module-scss-module__DjcIfq__textStyling",
  "ymmButton": "sportschedule-module-scss-module__DjcIfq__ymmButton",
});
